import script from "./AdminOnboardingManageFormOptionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOnboardingManageFormOptionsView.vue?vue&type=script&setup=true&lang=js"

import "./AdminOnboardingManageFormOptionsView.vue?vue&type=style&index=0&id=2d976562&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d976562"]])

export default __exports__